import formCloser from "./formCloser";
import { showHtmlMessageBox, showMessageBox } from "./messageBox";

// used in viewForm.js, engine.js, loader.js
async function showLoadFailedError(err, renderTarget, isHtmlMsg) {
    const msg = (err && err.userDisplayMessage) || "An unexpected error occurred.\nPlease contact technical support.";

    const msgBoxMethod = isHtmlMsg
        ? showHtmlMessageBox
        : showMessageBox;

    await msgBoxMethod("Error", msg + "\n\nThe form will now close.");

    const fc = formCloser(renderTarget);

    fc.closeForm();
}

// 2020-07-01 getErrorDetails, showRuleError moved to ruleSetExecutor.js

export default showLoadFailedError;